import { Transition } from "../../../core/flows/Transition";
import { PassengerDetailsContext } from "../../CheckoutPage/PassengerDetailsFlow/Context/PassengerDetailsContext";
import { PaymentContext } from "../../CheckoutPage/Payment/Context/PaymentContext";
import { SeatingMapContext } from "../../CheckoutPage/SeatingMap/Context/SeatingMapContext";
import { VoucherContext } from "../../CheckoutPage/Voucher/Context/VoucherContext";
import { SearchContext } from "../../Common/Search/Context/SearchContext";
import { SelectOfferContext } from "../../TrainOfferPage/SelectOfferFlow/Context/SelectOfferContext";
import { MainBookingContext } from "../Context/MainBookingContext";

export class MainBookingSelectOfferTransition extends Transition {
    constructor(entryStep: string, exitSteps: string[]) {
        super(entryStep, exitSteps);
    }

    onExecute(): string[] {        
        const context = this.getCtx<SelectOfferContext>("SelectOfferContext", this.entryStep)!;
        if (context.nextTo.includes("SearchFlow")) {
            const searchContext = this.getCtx<SearchContext>("searchContext", this.entryStep)!;
            this.setCtx<SearchContext>("searchContext", searchContext, this.entryStep)
        }
        if (context.nextTo.includes("CheckoutFlow")) {
            const passengerDetailsContext = new PassengerDetailsContext()
            this.setCtx<PassengerDetailsContext>("passengerDetailsContext", passengerDetailsContext, this.entryStep)

            const voucherContext = new VoucherContext()
            this.setCtx<VoucherContext>("voucherContext", voucherContext, this.entryStep)

            const paymentContext = new PaymentContext()
            this.setCtx<PaymentContext>("paymentContext", paymentContext, this.entryStep)

            const seatingMapContext = new SeatingMapContext()
            this.setCtx<SeatingMapContext>("seatingMapContext", seatingMapContext, this.entryStep)
        }

        if (context.nextTo.length > 0) {
            context.routeTo = context.nextTo
            context.nextTo = []
        }

        if (!context) {
            console.log("[Transition] No choice data available, using default exits");
            return this.exitSteps;
        }

        if (!(context.routeTo ?? []).every(step => this.exitSteps.includes(step))) {
            console.log(`[Transition] Invalid choice: ${context.routeTo}`);
            return [];
        }

        return [...(context?.routeTo ?? [])]
    }

}